import { iconLibrary } from './iconLibrary';
import { componentDurationMap } from './componentDurationMap';

export class Module {
  constructor(moduleData) {
    this.iconLibrary = iconLibrary;
    this.formIdentifier = moduleData.formIdentifier;
    this.componentDurationMap = componentDurationMap;
    this.defaultComponentName = 'PicatIframe';
    this.componentId = moduleData.comp_comp_id;
    this.compId = moduleData.comp_comp_id;
    this.componentDuration = moduleData.duration;
    this.finishedAt = moduleData.finishedAt;
    this.name = moduleData.cmtp_name;
    this.displayName = moduleData.display_name;
    this.displayDesc = moduleData.display_description || moduleData.description;
    this.skippable = moduleData.skippable;
    this.text = moduleData.text;
    this.links = moduleData.links;
    this.isWrapper = moduleData.isWrapper;
    this.id = moduleData.prcm_id;
    this.wrapperTitle = moduleData.wrapperTitle;
    this.wrapperDescription = moduleData.wrapperDescription;
    this.scales = moduleData.scales;
    this.normValue = moduleData.normValue;
    this.stepNumber = moduleData.prcs_step_number;
    this.action = moduleData.action;

    // for media Modules
    this.imagePath = moduleData.image_path;
    this.title = moduleData.title;
    this.path = moduleData.path;
    this.icon = this.imagePath
      ? () =>
          import(
            /* webpackChunkName: "[request]" */ `@shared/components/Icons/Icons/${this.imagePath}.vue`
          )
      : this.iconLibrary.get(this.componentId);
  }

  get isTraining() {
    return !this.required && this.skippable && [86, 87, 88].includes(this.id);
  }

  get isReport() {
    return this.action ? this.action === 'Report' : false;
  }

  get allowDiscontinue() {
    return this.name !== 'Scale';
  }

  get duration() {
    // TODO MVP1: ohne componentDurationMap umsetzen. Aus Datenbank über prop
    const duration = this.componentDurationMap.get(this.id);
    if (duration !== undefined) {
      return duration;
    }
    if (this.componentDuration) {
      return Math.ceil(this.componentDuration / 60);
    }
    return 8;
  }

  get componentName() {
    if (this.name === 'Form') return this.formIdentifier;
    return this.defaultComponentName;
  }
}
